import { Component, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
declare let jQuery: any;

@Component({
  selector: 'footer',
  templateUrl: 'footer.component.html',
  standalone: true
})
export class FooterComponent implements AfterViewInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngAfterViewInit() {
    const isBrowser = isPlatformBrowser(this.platformId);
    if (isBrowser) {
      const prefix = isBrowser ? '' : '/';
      jQuery(document).ready(function () {
        jQuery('.pie').load(prefix + 'assets/footer.html');
      });
    }
  }
}
